module.exports = {
      id: "register_end-usage",
      viewBox: "0 0 67.6 59.9",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#register_end",
      toString: function () {
        return this.url;
      }
    }